import { Injectable } from '@angular/core';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { BackendErrors, INotesTypeEntityDTO } from '@modeso/types__aumico-lib-notes-be';
import { Errors } from '../enums/errors.enum';
import { ILegalFormAndAccountBasis } from './../interfaces/ILegalFormAndAccountBasis.interface';

@Injectable({
    providedIn: 'root',
})
export class NotesTemplatesHelper {
    constructor() {}

    getSelectedNotesTypes(notesTypeSelection: INameId[], notesTypes: INotesTypeEntityDTO[]): INotesTypeEntityDTO[] {
        const selectedNotesTypes: INotesTypeEntityDTO[] = [];

        notesTypeSelection.forEach((selection: INameId) => {
            const filteredNotesType: INotesTypeEntityDTO = notesTypes.find(
                (notesType: INotesTypeEntityDTO) => notesType._id === selection.id,
            );
            selectedNotesTypes.push(filteredNotesType);
        });

        return selectedNotesTypes;
    }

    getErrorOfStatus409(reason: BackendErrors): string {
        if (reason === BackendErrors.Legal_Form_And_Account_Basis) {
            return Errors.legal_From_And_Account_Basis_Combination_Error;
        }

        return Errors.NameExistenceError;
    }

    prepareLegalFormOrAccountBasisSelectionOptions(
        legalFormOrAccountBasis: ILegalFormAndAccountBasis[],
        data: INameId,
    ): INameId[] {
        const selectionOptions: INameId[] = [];

        for (const iterator of legalFormOrAccountBasis) {
            let legalFormOrAccountBasisSelectionOption: INameId;

            if (data != null && iterator._id === data.id) {
                legalFormOrAccountBasisSelectionOption = { id: data.id, name: data.name };
            } else {
                legalFormOrAccountBasisSelectionOption = { id: iterator._id, name: iterator.name };
            }

            selectionOptions.push(legalFormOrAccountBasisSelectionOption);
        }

        return selectionOptions;
    }

    prepareSelectedLegalFormOrAccountBasisUpdateMode(
        legalFormsOrAccountBases: ILegalFormAndAccountBasis[],
        legalFormOrAccountBasis: string,
    ): INameId {
        let selection: INameId;

        for (const iterator of legalFormsOrAccountBases) {
            if (iterator._id === legalFormOrAccountBasis) {
                selection = { id: iterator._id, name: iterator.name };
            }
        }

        return selection;
    }
}
